<div class="position-relative d-flex flex-column gap-2 h-100">
  <div class="d-flex flex-column col-12 gap-2 p-0">
    <div
      class="d-flex flex-column align-items-start justify-content-between gap-1 p-0"
    >
      <div class="align-self-end sticky-top">
        <img
          style="cursor: pointer; width: 1.75rem"
          (click)="closeDialog()"
          src="assets/icons/group-sharing/cancel-white.svg"
          alt="Close"
        />
      </div>

      <div>
        <h2 mat-dialog-title class="cus-title">Let's enjoy together!</h2>
      </div>

      <div>
        <p mat-dialog-title class="cus-title">Delegate the selected ticket</p>
      </div>
    </div>
    <div
      class="d-flex justify-content-start align-items-center gap-2 col-12 p-0"
    >
      <span class="fs-5 text-white fw-boldish"
        ><p class="fs-5 mb-0">Event Name:</p></span
      >
      <p class="fs-5 mb-0">" {{ ticketDetails?.event }} "</p>
    </div>
    <div
      class="d-flex justify-content-start align-items-center gap-3 col-12 p-0 mt-2"
    >
      <span class="fs-6 text-white fw-boldish"
        >Number of empty tickets Available :
      </span>
      <p class="fs-6 mb-0">
        {{ availableTickets }}
      </p>
    </div>
    <div class="form-container gap-1 w-100">
      <form *ngIf="!userselected" class="example-form user-input">
        <mat-form-field appearance="fill" class="w-100 mx-1">
          <mat-label>Select user</mat-label>
          <input
            type="text"
            matInput
            #userInpute
            [formControl]="myControl"
            [value]="myControl.value"
            placeholder="Enter user name"
            [matAutocomplete]="auto"
          />
          <mat-hint class="text-light" *ngIf="!validInput"
            ><strong>Enter valid user!</strong></mat-hint
          >
          <mat-autocomplete #auto (optionSelected)="selectedItems($event)">
            <mat-option
              *ngFor="let user of filteredOptions | async"
              [value]="user.value"
            >
              {{ user.value }}</mat-option
            >
          </mat-autocomplete>
        </mat-form-field>
      </form>
      <div
        *ngIf="userselected"
        class="selected-user d-flex align-self-center align-items-center justify-content-center mx-2 mb-4 bg-white rounded-top border-bottom border-primary"
      >
        <mat-chip-list
          aria-label="user selection"
          class="w-90 bg-transparent overflow-hidden"
        >
          <mat-chip
            class="bg-custom-chip text-center p-1 gap-1 justify-content-between overflow-hidden border-box"
          >
            <span class="overflow-hidden text-nowrap span-w">{{
              selectedUsername
            }}</span>
            <button class="custom-btn p-1" (click)="deSelectItem()">
              <span
                ><img
                  src="assets/icons/group-sharing/cancel.svg"
                  alt=""
                  class="img-w"
              /></span>
            </button>
          </mat-chip>
        </mat-chip-list>
      </div>
      <div class="responsive mx-1">
        <button
          class="p-2"
          id="disabled"
          [disabled]="!availableTickets || !buttonActive"
          mat-flat-button
          (click)="assignTicket()"
        >
          Assign Ticket
        </button>
      </div>
    </div>

    <div
      class="participents-table-container"
      *ngIf="(tableData | async).length > 0"
      style="width: 100%; align-self: center"
    >
      <table mat-table [dataSource]="tableData" class="mat-elevation-z8">
        <ng-container matColumnDef="guestname">
          <th
            style="width: 50%"
            class="text-start text-dark"
            mat-header-cell
            *matHeaderCellDef
          >
            Participant Name
          </th>
          <td style="width: 50%" mat-cell *matCellDef="let element">
            <span
              [matTooltip]="
                element.invited
                  ? 'This user will be invited to Creatics Platform.'
                  : ''
              "
              >{{ element.guestname }}</span
            >
          </td>
        </ng-container>

        <ng-container matColumnDef="rsvpStatus">
          <th
            style="width: 30%"
            class="text-center text-dark"
            mat-header-cell
            *matHeaderCellDef
          >
            RSVP Status
          </th>
          <td
            style="width: 30%"
            class="text-center"
            mat-cell
            *matCellDef="let element"
          >
            <span
              class="rsvp-status rsvp-{{ element.rsvpStatus }}"
              [matTooltip]="rsvpTooltips[element.rsvpStatus]"
              matTooltipPosition="above"
              >{{ element.rsvpStatus }}</span
            >
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th
            style="width: 20%"
            class="text-center text-dark"
            mat-header-cell
            *matHeaderCellDef
          >
            Action
          </th>
          <td
            style="width: 20%"
            class="text-center"
            mat-cell
            *matCellDef="let element"
          >
            <button
              *ngIf="!element.invited && !element.newParticipant"
              mat-button
              class="mat-accent button-remove"
              label="Remove"
              matTooltip="Remove Existing Participant"
              matTooltipPosition="above"
              (click)="removeParticipant(element)"
            >
              Remove
            </button>
            <button
              *ngIf="element.invited || element.newParticipant"
              mat-icon-button
              class="mat-primary"
              label="Cancel"
              matTooltip="Remove New Participant"
              matTooltipPosition="above"
              (click)="removeParticipant(element)"
            >
              <mat-icon>close</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [ngClass]="{
            'new-participant': row.newParticipant,
            invited: row.invited
          }"
        ></tr>
      </table>
    </div>

    <div style="display: flex; align-self: flex-end; gap: 10px">
      <button
      mat-button
      id="cancel-btn"
      class="mb-2"
      label="Cancel"
      (click)="closeDialog()"
      >
        Cancel
      </button>
    </div>
  </div>

  <div
    *ngIf="!loaded && error"
    class="position-relative d-flex col-12 p-0 justify-content-center h-100"
  >
    <div
      class="d-flex flex-column col-12 align-items-start justify-content-between p-0"
    >
      <div class="d-flex col-12 p-0 align-items-start justify-content-between">
        <h2 mat-dialog-title class="cus-title">
          Oops... Something went wrong!
        </h2>
        <img
          style="cursor: pointer; width: 1.75rem"
          (click)="closeDialog()"
          src="assets/icons/group-sharing/cancel-white.svg"
          alt="Close"
        />
      </div>
      <p>
        Oops... Something went wrong. Please close this popup and try again. If
        the problem persists, contact support.
      </p>
    </div>
  </div>
</div>
